import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m10 17 5-5-5-5v10z",
  fill: "currentColor"
}));
export default SvgArrowRight;